module.exports = __webpack_public_path__ + "static/product2_2-1822190d4d11046da3b14f03af2fa35d.jpg";